import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeCar1 = ({autorizacUA, styles, handleClickSel13, handleClickSel18, handleClickSel14,
                  handleClickSel15, handleClickSel16, handleClickSel17, handleClickSel7, handleClickSel19,
                  handleClickSel20, handleClickSel21, handleClickSel22, handleClickSel23, 
                  handleClickSel24, handleClickSel25, handleClickSel26, handleClickSel29}) => {
  const a0501 = autorizacUA.findIndex( autorizac => autorizac === "0501" );
  // const a1003 = autorizacUA.findIndex( autorizac => autorizac === "1003" );
  const a0505 = autorizacUA.findIndex( autorizac => autorizac === "0505" );
  const a0510 = autorizacUA.findIndex( autorizac => autorizac === "0510" );
  const a0515 = autorizacUA.findIndex( autorizac => autorizac === "0515" );
  const a0520 = autorizacUA.findIndex( autorizac => autorizac === "0520" );
  const a0525 = autorizacUA.findIndex( autorizac => autorizac === "0525" );
  const a0528 = autorizacUA.findIndex( autorizac => autorizac === "0528" );
  const a0529 = autorizacUA.findIndex( autorizac => autorizac === "0529" );
  const a0530 = autorizacUA.findIndex( autorizac => autorizac === "0530" );
  const a0533 = autorizacUA.findIndex( autorizac => autorizac === "0533" );
  const a0535 = autorizacUA.findIndex( autorizac => autorizac === "0535" );
  const a0538 = autorizacUA.findIndex( autorizac => autorizac === "0538" );
  const a0539 = autorizacUA.findIndex( autorizac => autorizac === "0539" );
  const a0540 = autorizacUA.findIndex( autorizac => autorizac === "0540" );
  const a0545 = autorizacUA.findIndex( autorizac => autorizac === "0545" );
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large tint yellow icon"></i>
        CARTAS DE LUBRICACION
      </button>

      {a0501!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel13}>
          <i className="large eye dropper red icon"></i>
          Métodos de lubricación
        </button>
      }      
      {a0505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel14}>
          <i className="large tasks red icon"></i>
          Tareas
        </button>
      }      
      {a0510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel15}>
          <i className="large hourglass half red icon"></i>
          Frecuencias
        </button>
      }    
      {a0515!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel16}>
          <i className="large cogs red icon"></i>
          Aplicaciones / Espesantes
        </button>
      } 
      {a0520!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
          <i className="large thermometer quarter red icon"></i>
          Grados de lubricantes
        </button>
      } 
      {a0525!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
          <i className="large tint red icon"></i>
          Lubricantes
        </button>
      } 
      {a0530!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel24}>
          <i className="large newspaper red icon"></i>
          Stock de lubricantes en empresas
        </button>
      }
      {a0528!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel7}>
          <i className="large file alternate outline red icon"></i>
          Procedimientos de tareas de lubricación
        </button>
      }
      {/* {a0529!==-1 && */}
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel29}>
          <i className="large file alternate outline red icon"></i>
          Advertencias de tareas de lubricación
        </button>
      {/* } */}
      <Divider inverted />
      
      {a0535!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel20}>
          <i className="large stop circle outline red icon"></i>
          Generar rótulos
        </button>
      }
      {a0538!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
          <i className="large images outline red icon"></i>
          Asociar imágenes a los equipos
        </button>
      }
      {a0539!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel26}>
          <i className="large images outline red icon"></i>
          Asociar imágenes (Power point) a las secciones
        </button>
      }
      {a0540!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
          <i className="large print red icon"></i>
          Imprimir cartas de lubricación
        </button>
      } 
      {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel19}>
          <i className="large print red icon"></i>
          Cargar en el servidor las cartas de los equipos
        </button>
      }
      {a0540!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
          <i className="large print red icon"></i>
          Imprimir anexos de las cartas
        </button>
      } 
      {/* {localStorage.getItem('userLogin')==="felipe.albarracin@lubricaciondeclasemundial.com" &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
          <i className="large print red icon"></i>
          Imprimir anexos de las cartas
        </button>
      } */}
      {/* {localStorage.getItem('userLogin')==="kriztianhgra52@gmail.com" &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel25}>
          <i className="large print red icon"></i>
          Imprimir anexos de las cartas
        </button>
      } */}
      <Divider inverted />
      {a0545!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
          <i className="large chart bar red icon"></i>
          Informes
        </button>
      } 
    </div>
  )
};

export default HomeCar1
